import type { CookieService, Logger } from "@packages/common";
import { COOKIE_SERVICE, LOGGER } from "@packages/common";
import type { Config } from "@packages/config";
import { CONFIG } from "@packages/config";
import { Inject, Injectable } from "@webmotors/ioc";

import { AUTH_SERVICE } from "./auth.types";

@Injectable(AUTH_SERVICE)
export class AuthService {
  private readonly logger: Logger;

  /**
   * Constructor method
   *
   * @param cookie - The service used to remove items from cookie
   * @param loggerFactory - The logger service
   */
  constructor(
    @Inject(COOKIE_SERVICE) private readonly cookie: CookieService,
    @Inject(LOGGER) private readonly loggerFactory: Logger,
    @Inject(CONFIG) private readonly config: Config
  ) {
    this.logger = this.loggerFactory.create(AUTH_SERVICE);
  }

  /**
   * Logs the current logged user out
   *
   * @returns A promise that resolves to a boolean indicating success
   */
  async logout(): Promise<boolean> {
    this.logger.info("[Logout] Logging user out...");

    this.cookie.removeCookie(this.config.authCookieName);
    this.cookie.removeCookie(this.config.accessTokenCookieName!);
    this.cookie.removeCookie(this.config.refreshTokenCookieName!);

    this.logger.info("[Logout] User logged out.");
    return true;
  }
}
